import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import Vue from "vue";

const VUE_APP_NAME = require('../package.json').name;
const VUE_APP_VERSION = require('../package.json').version;
const APP_ENV = process.env.VUE_APP_ENVIRONMENT || 'development';
// noinspection JSUnresolvedFunction
if (APP_ENV !== 'development') {
    Sentry.init({
        Vue: Vue,
        environment: APP_ENV,
        release: `${VUE_APP_NAME}@${VUE_APP_VERSION}`,
        dsn: process.env.VUE_APP_SENTRY_DSN,
        integrations: [
            new Integrations.BrowserTracing({
                tracingOrigins: [process.env.VUE_APP_URL, /^\//],
            }),
        ],
        debug: APP_ENV  !==  'production',
        tracesSampleRate: APP_ENV === 'production' ? 0.2 : 1,
        tracingOptions: {
            trackComponents: true,
        },
        // Vue specific
        logErrors: APP_ENV === 'production' ? false : true,
        attachProps: true,
        attachStacktrace: true,
    });
}




